// extracted by mini-css-extract-plugin
export default {"wrapper":"quick_date_filter-module___wrapper___d409f6e2","title":"quick_date_filter-module___title___def95502","dates":"quick_date_filter-module___dates___ac7c9f2f"};